export default "ui-textcounter{display:block;width:100%}ui-textcounter .-negative{color:var(--ui-color-alert-red)}\n";